'use client';

import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { useSearchBox } from 'react-instantsearch';
const SearchResultsWrapperNext = t0 => {
  const $ = _c(3);
  const {
    children
  } = t0;
  const {
    query
  } = useSearchBox();
  const hasQuery = Boolean(query);
  const t1 = !hasQuery;
  let t2;
  if ($[0] !== children || $[1] !== t1) {
    t2 = <div hidden={t1}>{children}</div>;
    $[0] = children;
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
};
export default SearchResultsWrapperNext;